export default {
    menuList: state => state.user.routes,
    userInfoDetail: state => state.user.userInfoDetail,
    btnPermissions: state => state.user.btnPermissions,
    examineCountTotal: state => state.user.signCount
}


// WEBPACK FOOTER //
// ./src/store/getters.js